import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import actions from 'redux/action'
import ShareModal from 'page/SharePage/component/ShareModal'

/** 開啟全屏分享彈窗（取代跳轉 /share 路由） */
export default function useOpenShareModal() {
  const dispatch = useDispatch()

  return useCallback(() => {
    dispatch(actions.openGlobalModal({ children: ShareModal, props: {} }))
  }, [dispatch])
}
